function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 5.255h-5.642L13 4l-1.061-1.061L9 6.005 12 9l1.061-1.061-1.203-1.184H17.5v-1.5z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 5.255h5.642L16 4l1.061-1.061L20 6.005 17 9l-1.061-1.061 1.203-1.184H11.5v-1.5zM6.745 15.5V9.858L8 11l1.061-1.061L5.995 7 3 10l1.061 1.061 1.184-1.203V15.5h1.5z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.745 11.5v5.642L8 16l1.061 1.061L5.995 20 3 17l1.061-1.061 1.184 1.203V11.5h1.5z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 10.75,
  y: 10.75,
  width: 8.5,
  height: 8.5,
  rx: 1.25,
  stroke: "currentColor",
  strokeWidth: 1.5
});

function SvgSizeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgSizeIcon;